import { ALL_FISH_GROUP_ID } from 'views/bluviu-nutrition/features/scenarios-v2/utils/compare-result-utils';

export const removeSelectAllValue = (values: string[], selectAllKey: string): string[] =>
  values.filter((value) => value !== selectAllKey);

export const areAllValuesSelected = (values: string[], allValues: string[], selectAllKey: string): boolean =>
  values.includes(selectAllKey) || allValues.every((value) => values.includes(value));

export const getFirstAvailableOption = (allValues: string[]): string[] => (allValues[0] ? [allValues[0]] : []);

export const getFallbackSelection = (currentSelectedValues: string[], allValues: string[]): string[] =>
  currentSelectedValues[0] ? [currentSelectedValues[0]] : getFirstAvailableOption(allValues);

export const buildSelectAllSelection = (allValues: string[], selectAllKey: string): string[] => [selectAllKey, ...allValues];

export const toggleSelectionWithSelectAll = (
  newValue: string[],
  currentValue: string[],
  allValues: string[],
  selectAllKey = 'all'
): string[] => {
  const selectedValues = removeSelectAllValue(newValue, selectAllKey);
  const currentSelectedValues = removeSelectAllValue(currentValue, selectAllKey);

  const currentlyAllSelected = areAllValuesSelected(currentValue, allValues, selectAllKey);
  const isSelectingAll = newValue.includes(selectAllKey) && !currentlyAllSelected;
  const isUnselectingAll = !newValue.includes(selectAllKey) && currentValue.includes(selectAllKey);

  if (isSelectingAll) return buildSelectAllSelection(allValues, selectAllKey);
  if (isUnselectingAll) return getFirstAvailableOption(allValues);
  if (selectedValues.length === allValues.length) return buildSelectAllSelection(allValues, selectAllKey);
  if (selectedValues.length === 0) return getFallbackSelection(currentSelectedValues, allValues);

  return selectedValues;
};

export const isLastConcreteSelection = (values: string[], optionId: string, selectAllKey: string): boolean => {
  const concreteSelectedValues = removeSelectAllValue(values, selectAllKey);
  return concreteSelectedValues.length === 1 && concreteSelectedValues[0] === optionId;
};

export const resolveFishGroupSelection = (value: string[], currentValue: string[]): string[] => {
  if (value.length === 0) {
    return [ALL_FISH_GROUP_ID];
  }

  const previousHadAll = currentValue.includes(ALL_FISH_GROUP_ID);
  const nextHasAll = value.includes(ALL_FISH_GROUP_ID);
  const selectedConcreteIds = value.filter((id) => id !== ALL_FISH_GROUP_ID);

  if (nextHasAll && !previousHadAll) {
    return [ALL_FISH_GROUP_ID];
  }

  if (previousHadAll && selectedConcreteIds.length > 0) {
    return selectedConcreteIds;
  }

  if (selectedConcreteIds.length === 0) {
    return [ALL_FISH_GROUP_ID];
  }

  return selectedConcreteIds;
};
